import gql from 'graphql-tag';

export const GET_ADMIN_EDITING_COMPANIES = gql`
	query GetAdminEditingCompanies($query: JSON) {
		editingCompanies(query: $query) {
			id
			name
			email
			phoneNumber
			editors {
				name
			}
			editingManager {
				id
				name
				email
				phoneNumber
			}
		}
	}
`;

export const CREATE_EDITING_COMPANY = gql`
	mutation CreateEditingCompany($name: String!, $email: String!, $phoneNumber: String!) {
		createEditingCompany(name: $name, email: $email, phoneNumber: $phoneNumber) {
			name
			email
			phoneNumber
			id
		}
	}
`;
